import countries from '../../helpers/countries'
import VatRatesEU from '../../helpers/vat-rates-eu'
import _ from 'lodash'
import JSEncrypt from 'jsencrypt'

function getUrlParam(param) {
  const url_string = window.location.href
  const url = new URL(url_string)
  return url.searchParams.get(param) || 0
}

function subtotalForMultipleLicences(quantity, course) {
  if (!quantity) {
    quantity = 1
  }

  let price = course.price

  if (!_.isEmpty(course.price_list)) {
    let result = course.price_list
      .map((el) => {
        el.activatesAfter = parseInt(el.activatesAfter)
        return el
      })
      .sort((a, b) => {
        return a.activatesAfter - b.activatesAfter
      })
      .reverse()
      .find((el) => {
        return el.activatesAfter <= quantity
      })
  }

  return price * quantity
}
function finalPriceForMultipleLicences(quantity, course) {
  if (!quantity) {
    quantity = 1
  }

  let price = course.price

  if (!_.isEmpty(course.price_list)) {
    let result = course.price_list
      .map((el) => {
        el.activatesAfter = parseInt(el.activatesAfter)
        return el
      })
      .sort((a, b) => {
        return a.activatesAfter - b.activatesAfter
      })
      .reverse()
      .find((el) => {
        return el.activatesAfter <= quantity
      })

    if (result) {
      price = result.value
    }
  }

  return price * quantity
}

function percentageBasedReduction(price, amount) {
  let result = (price * (100 - amount)) / 100
  if (result <= 0) {
    return 0
  }
  return result
}

function amountBasedReduction(price, amount) {
  let result = price - amount
  if (result <= 0) {
    return 0
  }
  return result
}

function calculatePrice(oldPrice, promoCode) {
  if (!promoCode) {
    return oldPrice
  }
  if (promoCode.type === 'percentage') {
    return percentageBasedReduction(oldPrice, promoCode.amount)
  } else if (promoCode.type === 'amount') {
    return amountBasedReduction(oldPrice, promoCode.amount)
  }
}

function calculatePriceForFreeProductWithOrderBumps(course, selectedOrderBumps) {
  if (selectedOrderBumps.length) {
    let orderBumpPrice = _.sumBy(selectedOrderBumps, 'price')
    // let orderBumpOldPrice = _.sumBy(state.selectedOrderBumps, 'course.price')

    course.subtotal = course.subtotal + orderBumpPrice
    course.finalPrice = course.finalPrice + orderBumpPrice

    return course
  }

  return course
}

function updateURLSearchParam(name, value) {
  const params = new URLSearchParams(location.search)
  params.set(name, value)

  window.history.replaceState({}, '', `${location.pathname}?${params}`)
}

function finalPriceForPriceVariants(course, hasValidPromoCode, promoCode) {
  let v = getUrlParam('v')
  let basePrice = _.get(
    course,
    `price_variants_settings[${v}].price`,
    _.get(course, 'price_variants_settings[0].price', course.price),
  )

  if (hasValidPromoCode) {
    return calculatePrice(basePrice, promoCode)
  }

  return basePrice
}

function priceWithOrderBumps(course, selectedOrderBumps) {
  if (selectedOrderBumps.length) {
    let orderBumpPrice = _.sumBy(selectedOrderBumps, 'price')
    // let orderBumpOldPrice = _.sumBy(state.selectedOrderBumps, 'course.price')

    course.subtotal = course.subtotal + orderBumpPrice
    course.finalPrice = course.finalPrice + orderBumpPrice

    return course
  }

  return course
}

export default {
  state: {
    hasAccess: false,
    publishableApiKey: null,
    VatRatesEU,
    countries,
    promoCode: {},
    checkoutType: null,
    publicRSA: null,
    course: {},
    page: {},
    user: {},
    membershipOptions: {},
    loading: true,
    view: 'register',
    cypher: null,
    cardData: {
      cardNumber: '',
      cardMonth: '',
      cardYear: '',
      cardCvv: '',
    },
    selectedOrderBumps: [],
    quantity: 1,
    currentMo: 'default',
    currentPlan: 'one',
    errors: {},
    registrationData: {
      email: null,
      name: null,
      password: null,
    },
  },
  actions: {
    generateCypher({ commit, state }) {
      const cardData = state.cardData

      // Validate card data first
      if (!cardData.cardNumber || !cardData.cardMonth || !cardData.cardYear || !cardData.cardCvv) {
        return false
      }

      const number = cardData.cardNumber.replace(/\s/g, '')
      const cd = `${number}|${cardData.cardMonth}/${cardData.cardYear}|${cardData.cardCvv}|${document.location.origin}`

      try {
        const decoded = Buffer.from(state.publicRSA, 'base64').toString('ascii')
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(decoded)
        const cypher = encrypt.encrypt(cd)

        commit('setCypher', cypher)
        return cypher
      } catch (error) {
        console.error('Cypher generation failed:', error)
        return false
      }
    },
    regenerateCypher({ dispatch, commit }) {
      commit('setCypher', null)

      return dispatch('generateCypher')
    },
    removePromoCode({ commit }) {
      document.cookie = 'promo_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path = /;'
      commit('setPromoCode', null)
    },
    checkPromoCodeOnLogin({ dispatch, state }) {
      if (!state.promoCode?.code) return

      if (state.mode === 'single') {
        axios
          .post('/json/promo-code', {
            code: state.promoCode.code,
            mode: 'single',
            course_id: state.course.id,
          })
          .catch((error) => {
            dispatch('removePromoCode')
          })
      } else {
        axios
          .post('/json/promo-code', {
            code: state.promoCode.code,
            mode: 'subscription',
          })
          .catch((error) => {
            dispatch('removePromoCode')
          })
      }
    },
    checkPlanParams({ commit, state }) {
      let currentPlan = getUrlParam('plan')
      let currentMo = getUrlParam('option')

      if (currentPlan) {
        commit('setCurrentPlan', currentPlan)
      }
      if (currentMo) {
        commit('setCurrentMo', currentMo)
      }
    },
    getCheckoutData({ commit, state }) {
      return axios
        .post(window.location.href)
        .then(({ data }) => {
          state.course = _.get(data, 'course')
          state.page = _.get(data, 'page')
          state.promoCode = _.get(data, 'promo_code')
          state.checkoutType = _.get(data, 'checkout_type')
          state.user = _.get(data, 'student')
          state.membershipOptions = _.get(data, 'membership_options')
          state.publicRSA = _.get(data, 'publicRSA')
          state.publishableApiKey = _.get(data, 'publishable_api_key')

          return data
        })
        .then((data) => {
          commit('saleLimitExceeded', _.get(data, 'sale_limit_exceeded', false))
        })
        .then(() => {
          commit('turnLoadingOff')
        })
    },
  },
  mutations: {
    saleLimitExceeded(state, payload) {
      if (payload) {
        state.course.enrollment_disabled = true
      }
    },
    updateHasAccess(state, payload) {
      state.hasAccess = payload
    },
    turnLoadingOff(state) {
      state.loading = false
    },
    toggleOrderBump(state, payload) {
      if (state.selectedOrderBumps.find((ob) => ob.id === payload.id)) {
        return (state.selectedOrderBumps = state.selectedOrderBumps.filter((ob) => ob.id !== payload.id))
      }
      state.selectedOrderBumps = [...state.selectedOrderBumps, payload]
    },
    setRegistrationData(state, data) {
      state.registrationData = {
        ...state.registrationData,
        ...data,
      }
    },
    setPromoCode(state, promoCode) {
      state.promoCode = promoCode
    },
    setCypher(state, cypher) {
      state.cypher = cypher
    },
    setCardData(state, cardData) {
      state.cardData = { ...state.cardData, ...cardData }
    },
    clearCardData(state) {
      state.cardData = {
        cardNumber: '',
        cardMonth: '',
        cardYear: '',
        cardCvv: '',
      }
      state.cypher = null
    },
    setCurrentPlan(state, plan) {
      state.currentPlan = plan
      updateURLSearchParam('plan', plan)
    },
    setCurrentMo(state, mo) {
      state.currentMo = mo
      updateURLSearchParam('option', mo)
    },
    setSelectedPlan(state, plan) {
      state.selectedPlanDetails = plan
    },
    updateErrors(state, errors) {
      state.errors = errors
    },
    updateQuantity(state, value) {
      state.quantity = parseInt(value)
      if (_.get(state, 'course.multiple_licences')) {
        updateURLSearchParam('q', value)
      }
    },
    setView(state, name) {
      state.view = name
    },
    updateUser(state, user) {
      state.user = { ...state.user, ...user }
    },
  },
  getters: {
    chosenPlan(state) {},
    studentSuggestedPrice(state) {
      return _.get(state, 'course.student_suggested_price', null)
    },
    priceVariant(state) {
      let v = getUrlParam('v')
      return _.get(state, `course.price_variants_settings[${v}]`, _.get(state, 'course.price_variants_settings[0]'))
    },
    promoCodeIsValidForCourse(state, getters) {
      if (!state.course) {
        return null
      }

      const promoCode = _.get(state, 'promoCode')

      if (!promoCode) return false
      if (!_.get(promoCode, 'is_active', false)) return false

      if (promoCode.mode === 'single' && !promoCode.course_id) return true
      if (promoCode.mode === 'multi' && !promoCode.course_id) return true
      if (promoCode.course_id === state.course.id) return true
      if (promoCode.mode === 'all') return true

      return false
    },
    courseAfterPriceReductions(state, getters) {
      if (!state.course) {
        return null
      }

      let course = state.course

      if (course.is_free && !_.isNil(course.student_suggested_price)) {
        return {
          ...course,
          subtotal: course.student_suggested_price,
          finalPrice: course.student_suggested_price,
        }
      }

      if (course.is_free) {
        return calculatePriceForFreeProductWithOrderBumps(
          {
            ...course,
            subtotal: 0,
            finalPrice: 0,
          },
          state.selectedOrderBumps,
        )
      }

      if (course.student_suggested_price) {
        return {
          ...course,
          subtotal: course.student_suggested_price,
          finalPrice: course.student_suggested_price,
        }
      }

      if (course.price_variants) {
        return {
          ...course,
          subtotal: _.round(finalPriceForPriceVariants(course, null, null)),
          finalPrice: _.round(finalPriceForPriceVariants(course, getters.promoCodeIsValidForCourse, state.promoCode)),
        }
      }

      if (course.multiple_licences) {
        return {
          ...course,
          subtotal: _.round(subtotalForMultipleLicences(state.quantity, course)),
          finalPrice: _.round(finalPriceForMultipleLicences(state.quantity, course)),
        }
      }

      if (getters.promoCodeIsValidForCourse) {
        return priceWithOrderBumps(
          {
            ...course,
            current_price: _.round(calculatePrice(course.price, state.promoCode)),
            subtotal: _.round(calculatePrice(course.price, null)),
            finalPrice: _.round(calculatePrice(course.price, state.promoCode)),
          },
          state.selectedOrderBumps,
        )
      }

      if (course.hasActivePromo) {
        return priceWithOrderBumps(
          {
            ...course,
            subtotal: _.round(course.price),
            finalPrice: _.round(course.promo_price),
          },
          state.selectedOrderBumps,
        )
      }

      return priceWithOrderBumps(
        {
          ...course,
          subtotal: course.price,
          finalPrice: course.price,
        },
        state.selectedOrderBumps,
      )
    },
    currentMo(state, getters) {
      if (state.checkoutType === 'single') {
        return null
      }

      return getters.plans.find((mo) => mo.header === state.currentMo) || getters.plans[0]
    },
    currentPlan(state, getters) {
      if (state.checkoutType === 'single') {
        return null
      }

      let plan = getters.currentMo?.plans.find((element) => element.name === state.currentPlan)

      if (plan) {
        return plan
      }

      return _.get(getters, 'currentMo.plans[0]', null)
    },
    checkout_info(state) {
      if (_.get(state, 'membershipOptions.display_checkout_info')) {
        return _.get(state, 'membershipOptions.checkout_info')
      }
      return null
    },
    trial(state) {
      if (_.get(state, 'membershipOptions.trial')) {
        return {
          amount: _.get(state, 'membershipOptions.trial_amount'),
          days: _.get(state, 'membershipOptions.trial_days'),
        }
      }
      return null
    },
    plans(state) {
      if (state.checkoutType === 'single') {
        return []
      }

      return state.membershipOptions.map((mo) => {
        let plans = []
        if (mo.one) {
          let one_amount = mo.one_amount
          if (state.promoCode && _.includes([null, 1], state.promoCode.membership_option)) {
            one_amount = calculatePrice(one_amount, state.promoCode)
          }
          plans.push({
            name: 'one',
            title: 'monthly',
            price: one_amount,
            oldPrice: mo.one_amount,
            monthlyPrice: one_amount / 1,
          })
        }
        if (mo.three) {
          let three_amount = mo.three_amount
          if (state.promoCode && _.includes([null, 3], state.promoCode.membership_option)) {
            three_amount = calculatePrice(three_amount, state.promoCode)
          }
          plans.push({
            name: 'three',
            title: 'quarterly',
            price: three_amount,
            oldPrice: mo.three_amount,
            monthlyPrice: three_amount / 3,
          })
        }
        if (mo.six) {
          let six_amount = mo.six_amount
          if (state.promoCode && _.includes([null, 6], state.promoCode.membership_option)) {
            six_amount = calculatePrice(six_amount, state.promoCode)
          }
          plans.push({
            name: 'six',
            title: 'half yearly',
            price: six_amount,
            oldPrice: mo.six_amount,
            monthlyPrice: six_amount / 6,
          })
        }
        if (mo.twelve) {
          let twelve_amount = mo.twelve_amount
          if (state.promoCode && _.includes([null, 12], state.promoCode.membership_option)) {
            twelve_amount = calculatePrice(twelve_amount, state.promoCode)
          }
          plans.push({
            name: 'twelve',
            title: 'yearly',
            price: twelve_amount,
            oldPrice: mo.twelve_amount,
            monthlyPrice: twelve_amount / 12,
          })
        }
        if (mo.lifetime) {
          let lifetime_amount = mo.lifetime_amount
          if (state.promoCode && _.includes([null, -1], state.promoCode.membership_option)) {
            lifetime_amount = calculatePrice(lifetime_amount, state.promoCode)
          }
          plans.push({
            name: 'lifetime',
            title: 'one time',
            price: lifetime_amount,
            oldPrice: mo.lifetime_amount,
          })
        }

        mo.plans = plans

        return mo
      })
    },
  },
}
